import React, { useState } from 'react';
import {
    TableRow,
    TableCell,
    Collapse,
    Card,
    Typography,
    Switch
} from '@mui/material';
import VendorChildTable from './vendorChildTable';
import ActionButtons from '../../dashboard/actionButtons';
import EditTextField from '../../../overrides/editField';
import {
    updateVendorWatcher,
    deleteVendorWatcher
} from '../../../../redux/actionCreators/admin/vendorManagement';
import { useDispatch } from 'react-redux';
import { emailValidation, phoneValidation } from '../employee/commonRegex';

const VendorTableRow = ({ rowData, divisionId }) => {
    const dispatch = useDispatch();

    const [expandOpen, setExpandOpen] = useState(false);
    const [status, setStatus] = useState('list');
    const [editData, setEditData] = useState({});
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

    const [formErrors, setFormErrors] = useState({
        GATEWAY_ID: null,
        PAYMENT_KEY: null,
        PAYMENT_SECRET: null,
    });

    const [emailValid, setEmailValid] = useState(true);
    const [phoneValid, setPhoneValid] = useState(true);

    const handleEditChange = (e) => {
        const { name, value ,checked} = e.target;
        if(name === 'bIsActive'){
            setEditData({ ...editData, [name]: checked })
        }

        else{
            setEditData({ ...editData, [name]: value })
        }
        setFormErrors(prev => ({ ...prev, [name]: null }));

        if (name === 'CEMAILID') setEmailValid(emailValidation(value));
        if (name === 'CMOBILENUMBER') setPhoneValid(phoneValidation(value));
    };

    const clearFormError = (field) => {
        setFormErrors(prev => ({
            ...prev,
            [field]: null,
        }));
    };


    const validatePaymentFields = () => {
        let errors = {};
        let hasError = false;

        if (editData.GATEWAY_ALLOWED) {
            if (!editData.GATEWAY_ID) {
                errors.GATEWAY_ID = 'Payment Gateway is required';
                hasError = true;
            }
            if (!editData.PAYMENT_KEY) {
                errors.PAYMENT_KEY = 'Payment Key is required';
                hasError = true;
            }
            if (!editData.PAYMENT_SECRET) {
                errors.PAYMENT_SECRET = 'Payment Secret is required';
                hasError = true;
            }
        }

        setFormErrors(prev => ({ ...prev, ...errors }));
        return !hasError;
    };

    const handleEdit = () => {
        setEditData({
            ...rowData,
            GATEWAY_ALLOWED: Number(rowData.gateway_allowed) === 1,
            GATEWAY_ID: rowData.gateway_id,
            PAYMENT_KEY: rowData.payment_key,
            PAYMENT_SECRET: rowData.payment_secret,
        });
        setStatus('edit');
        setExpandOpen(true);
    };

    const handleDelete = async () => {
        await dispatch(deleteVendorWatcher(rowData.NID, {
            data: { ACTION: 'DELETE', SDIVISIONID: divisionId }
        }));
        setDeleteDialogOpen(false);
    };

    const tickIconFunction = () => {
    if (!validatePaymentFields()) return;

    const payload = {
        ACTION: 'UPDATE',
        SDIVISIONID: divisionId,

        CVENDORID: editData.CVENDORID,
        CVENDORNAME: editData.CVENDORNAME,
        CVENDORDESC: editData.CVENDORDESC,
        CVENDORADDRESS: editData.CVENDORADDRESS,
        CEMAILID: editData.CEMAILID,
        CMOBILENUMBER: editData.CMOBILENUMBER,
        CLANDLINENUMBER: editData.CLANDLINENUMBER,
        NDIVISIONID: String(editData.nDivisionID),
        GATEWAY_ALLOWED: editData.GATEWAY_ALLOWED ? 1 : 0,
        NID:editData.NID,
        bIsActive :editData.bIsActive
    };

    if (editData.GATEWAY_ALLOWED) {
        payload.GATEWAY_ID = editData.GATEWAY_ID;
        payload.PAYMENT_KEY = editData.PAYMENT_KEY;
        payload.PAYMENT_SECRET = editData.PAYMENT_SECRET;
    }

    dispatch(updateVendorWatcher(rowData.NID, payload));
    setStatus('list');
};


    const cancelIconFunction = () => {
        setEditData({});
        setFormErrors({});
        setEmailValid(true);
        setPhoneValid(true);
        setStatus('list');
    };

    return (
        <>
            <TableRow hover>
                {status === 'list' ? (
                    <>
                        <TableCell>{rowData.NID}</TableCell>
                        <TableCell>{rowData.CVENDORID}</TableCell>
                        <TableCell>{rowData.CVENDORNAME}</TableCell>
                        <TableCell>{rowData.CVENDORDESC}</TableCell>
                        <TableCell>{rowData.CVENDORADDRESS}</TableCell>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.bIsActive === true ? 'Active' : 'Deactive'}
                            </Typography>
                        </TableCell>
                    </>
                ) : (
                    <>
                        <TableCell>{rowData.NID}</TableCell>
                        <TableCell>{rowData.CVENDORID}</TableCell>
                        <TableCell>
                            <EditTextField name="CVENDORNAME" value={editData.CVENDORNAME || ''} onChange={handleEditChange} />
                        </TableCell>
                        <TableCell>
                            <EditTextField name="CVENDORDESC" value={editData.CVENDORDESC || ''} onChange={handleEditChange} />
                        </TableCell>
                        <TableCell>
                            <EditTextField name="CVENDORADDRESS" value={editData.CVENDORADDRESS || ''} onChange={handleEditChange} />
                            
                        </TableCell>
                        <TableCell align="left">
                                                    {/* <Typography variant='t14_600'>
                                                        {editData.bIsActive === true ? 'true' : 'false'}
                                                    </Typography> */}
                                                    <Switch 
                                                        checked={editData.bIsActive === true ? true : false} 
                                                        // defaultChecked={editData.bIsActive === true ? true : false}
                                                        onChange={handleEditChange}
                                                        color="primary" 
                                                        name='bIsActive'
                                                    />
                                                </TableCell>
                    </>
                )}

                <TableCell align="right">
                    <ActionButtons
                        status={status}
                        setStatus={setStatus}
                        expandOpen={expandOpen}
                        setExpandOpen={setExpandOpen}
                        type="vendor"
                        tickIconFunction={tickIconFunction}
                        handleDelete={handleDelete}
                        handleEdit={handleEdit}
                        cancelIconFunction={cancelIconFunction}
                        setDeleteDialogOpen={setDeleteDialogOpen}
                        deleteDialogOpen={deleteDialogOpen}
                    />
                </TableCell>
            </TableRow>

            <TableRow>
                <TableCell colSpan={7} sx={{ p: 0 }}>
                    <Collapse in={expandOpen} unmountOnExit>
                        <Card sx={{ bgcolor: 'grey.200' }}>
                            <VendorChildTable
                                status={status}
                                expandOpen={expandOpen}
                                editData={editData}
                                setEditData={setEditData}
                                handleEditChange={handleEditChange}
                                formErrors={formErrors}
                                emailValid={emailValid}
                                phoneValid={phoneValid}
                                rowData={rowData}
                                clearFormError={clearFormError}  
                            />
                        </Card>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

export default VendorTableRow;
